import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PostCard from "@/components/PostCard";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

export default function RelatedArticles({ slug, category }) {
    const [related, setRelated] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!slug) return;
        let active = true;
        (async () => {
            try {
                const { data } = await api.get(`/posts/${slug}/related?limit=3`);
                if (active) setRelated(Array.isArray(data) ? data : []);
            } catch {
                if (active) setRelated([]);
            } finally {
                if (active) setLoading(false);
            }
        })();
        return () => { active = false; };
    }, [slug]);

    if (loading || related.length === 0) return null;

    const label = category ? category.charAt(0).toUpperCase() + category.slice(1) : "Articles";

    return (
        <section
            className="border-t border-zinc-800 mt-24"
            data-testid="related-articles"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
                <Reveal className="flex items-end justify-between border-b border-zinc-800 pb-6 mb-10">
                    <div>
                        <div className="overline mb-3">// Keep Reading</div>
                        <h2 className="font-display text-4xl md:text-5xl text-white tracking-tight leading-none">
                            More {label}<span className="text-[#FFD000]">.</span>
                        </h2>
                    </div>
                </Reveal>
                <Stagger className="grid md:grid-cols-3 gap-px bg-zinc-800" stagger={0.12}>
                    {related.map(p => (
                        <StaggerItem key={p.id || p.slug} className="bg-[#0A0A0A]">
                            <PostCard post={p} />
                        </StaggerItem>
                    ))}
                </Stagger>
            </div>
        </section>
    );
}
